import { render, staticRenderFns } from "./configureRemoteSelect.vue?vue&type=template&id=498c01d2&scoped=true"
import script from "./configureRemoteSelect.vue?vue&type=script&lang=js"
export * from "./configureRemoteSelect.vue?vue&type=script&lang=js"
import style0 from "./configureRemoteSelect.vue?vue&type=style&index=0&id=498c01d2&prod&lang=scss&scoped=true"
import style1 from "./configureRemoteSelect.vue?vue&type=style&index=1&id=498c01d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c01d2",
  null
  
)

export default component.exports